import { useContext } from 'preact/hooks';
import TranslationContext from './translationContext';

export default function Trans({ transKey }) {
    const translations = useContext(TranslationContext);

    // eslint-disable-next-line no-prototype-builtins
    return <>{translations.hasOwnProperty(transKey) ? translations[transKey] : transKey}</>;
}

export const useTrans = () => {
    const translations = useContext(TranslationContext);

    return {
        get(key: string) {
            // eslint-disable-next-line no-prototype-builtins
            return translations.hasOwnProperty(key) ? translations[key] : key;
        },
    };
};
